import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import type { UserCohort } from '../store/store';
import { bizchatSidepaneSharedStore } from '../store/store';

/**
 * Returns the UserCohort for the given MailboxInfo.
 */
export function getUserCohort(mailboxInfo: MailboxInfo): UserCohort | undefined {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    return bizchatSidepaneSharedStore().hasBizchatAcquisitionMap.get(accountKey)?.userCohort;
}
